import { BaseViewModel } from "../../common/BaseViewModel";
import * as Format from "../../common/FormatFunctions";
import * as ApiService from "../../common/CloudService/ApiService";
import { CrudlStatus } from "../../common/config/AppConstants";
import * as UIMap from "../../common/PrimeComponents";
export class StatisticViewModel extends BaseViewModel {
  constructor(updateState, showError, showSuccess, showEmpty) {
    super();
    this.updateState = updateState;
    this.showError = showError;
    this.showSuccess = showSuccess;
    this.showEmpty = showEmpty;
  }

  showLoadingScreen = () => {
    this.updateState("loaded", false);
  };

  hideLoadingScreen = () => {
    this.updateState("loaded", true);
  };

  getStatistics = async (statisticRequest, stateVariables) => {
    statisticRequest.codeTag = this.codeTag;
    statisticRequest.userId = this.userId;

    let statisticResponse = await ApiService.statisticsCreate(statisticRequest);
    if (statisticResponse.errorCode === 0) {
      // this.showSuccess("Statistic", CrudlStatus.CREATE);
    } else {
      //this.showError("Statistic", CrudlStatus.CREATE);
    }

    return statisticResponse;
  };

  getCustomers = async () => {
    var customerResponse = await this.getCustomerListByCodeTag();
    if (Format.isNotNull(customerResponse.businesses)) {
      this.updateState("customerList", customerResponse.businesses);
      this.logger.info(customerResponse.businesses);
      var customerArray = UIMap.getDropdownOptionsExtension(
        customerResponse.businesses,
        "businessName",
        "id"
      );
      this.updateState("customerOptions", customerArray);
    } else {
      this.showError("Customer", CrudlStatus.LIST);
    }
  };

  getProducts = async () => {
    var productResponse = await this.getProductListByCodeTag();
    if (Format.isNotNull(productResponse.productList)) {
      this.updateState("productList", productResponse.productList);
      this.logger.info(productResponse.productList);
      var customerArray = UIMap.getDropdownOptionsExtension(
        productResponse.productList,
        "name",
        "id"
      );
      this.updateState("productOptions", customerArray);
    } else {
      this.showError("Product", CrudlStatus.LIST);
    }
  };

  getParts = async () => {
    var partResponse = await this.getPartListByCodeTag();
    if (Format.isNotNull(partResponse.partList)) {
      this.updateState("partList", partResponse.partList);
      this.logger.info(partResponse.partList);
    } else {
      this.showError("Part", CrudlStatus.LIST);
    }
  };

  getSites = async () => {
    var siteResponse = await this.getSiteListByCodeTag();
    if (Format.isNotNull(siteResponse.siteList)) {
      this.updateState("siteList", siteResponse.siteList);
      var siteArray = UIMap.getDropdownOptionsExtension(
        siteResponse.siteList,
        "siteName",
        "id"
      );
      this.updateState("siteOptions", siteArray);
      this.logger.info(siteResponse.siteList);
    } else {
      this.showError("Site", CrudlStatus.LIST);
    }
  };

  getCatalogues = async () => {
    var catalogueResponse = await this.getCatalogueListByCodeTag();
    if (Format.isNotNull(catalogueResponse.catalogueList)) {
      this.updateState("catalogueList", catalogueResponse.catalogueList);
      var catalgoueArray = UIMap.getDropdownOptions(
        catalogueResponse.catalogueList
      );
      this.updateState("catalgoueOptions", catalgoueArray);
      this.logger.info(catalogueResponse.catalogueList);
    } else {
      this.showError("Catalogue", CrudlStatus.LIST);
    }
  };

  getCategorys = async id => {
    var categoryResponse = await this.getCategoryListByCatalogueId(id);
    if (Format.isNotNull(categoryResponse.categoryList)) {
      this.updateState("categoryList", categoryResponse.categoryList);
      this.logger.info(categoryResponse.categoryList);
      var categoryArray = UIMap.getDropdownOptions(
        categoryResponse.categoryList
      );
      this.updateState("categoryOptions", categoryArray);
    } else {
      this.showError("Category", CrudlStatus.LIST);
    }
  };

  reloadDataAfterExecute = (
    statistics,
    apiResponse,
    type,
    externalStateValues
  ) => {
    var updatedStatisticList = [];
    if (type === CrudlStatus.CREATE) {
      updatedStatisticList = this.reloadAfterCreate(
        statistics,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.UPDATE) {
      updatedStatisticList = this.reloadAfterUpdate(
        statistics,
        apiResponse,
        externalStateValues
      );
    }
    if (type === CrudlStatus.DELETE) {
      updatedStatisticList = this.reloadAfterDelete(
        statistics,
        apiResponse,
        externalStateValues
      );
    }

    this.updateState("statisticList", updatedStatisticList);
  };

  reloadAfterCreate = (statisticList, apiResponse, externalStateValues) => {
    if (statisticList === undefined || statisticList === null) {
      statisticList = [];
    }
    var statisticBean = externalStateValues.statisticBean;
    statisticBean.id = apiResponse.id;
    statisticBean.lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;

    statisticList.push(statisticBean);

    return statisticList;
  };

  reloadAfterUpdate = (statisticList, apiResponse, externalStateValues) => {
    var i = 0;
    statisticList.forEach(e => {
      if (apiResponse.id === e.id) {
        statisticList[i] = externalStateValues.statisticBean;
        statisticList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
      }
      i++;
    });

    return statisticList;
  };

  reloadAfterDelete = (statisticList, apiResponse, externalStateValues) => {
    var i = 0;
    statisticList.forEach(e => {
      //DELETE
      if (apiResponse.id === e.id) {
        statisticList.splice(i, 1);
      }
      i++;
    });

    return statisticList;
  };
  //   executeCRUDLAction = async (crudlStatus, stateVariables) => {
  //     let statisticRequest = CloudService.StatisticRequest.constructFromObject(
  //       stateVariables.statisticBean
  //     );
  //     if (crudlStatus === CrudlStatus.CREATE) {
  //       return await this.createStatistic(statisticRequest, stateVariables);
  //     }
  //     if (crudlStatus === CrudlStatus.UPDATE) {
  //       return await this.updateStatistic(statisticRequest, stateVariables);
  //     }
  //     if (crudlStatus === CrudlStatus.DELETE) {
  //       return await this.deleteStatistic(statisticRequest);
  //     }
  //   };

  //   createStatistic = async (statisticRequest, stateVariables) => {
  //     statisticRequest.codeTag = this.codeTag;
  //     statisticRequest.userId = this.userId;

  //     let statisticResponse = await ApiService.statisticCreate(statisticRequest);
  //     if (statisticResponse.errorCode === 0) {
  //       this.showSuccess("Statistic", CrudlStatus.CREATE);
  //     } else {
  //       this.showError("Statistic", CrudlStatus.CREATE);
  //     }

  //     return statisticResponse;
  //   };

  //   deleteStatistic = async statisticRequest => {
  //     //RESET PRODUCT REQUEST
  //     var request = {};
  //     request.codeTag = this.codeTag;
  //     request.userId = this.userId;
  //     request.id = statisticRequest.id;
  //     request.lastUpdatedDateTime = statisticRequest.lastUpdatedDateTime;

  //     let statisticResponse = await ApiService.statisticDelete(request);
  //     if (statisticResponse.errorCode === 0) {
  //       this.showSuccess("Statistic", CrudlStatus.DELETE);
  //     } else {
  //       this.showError("Statistic", CrudlStatus.DELETE);
  //     }

  //     return statisticResponse;
  //   };

  //   updateStatistic = async (statisticRequest, stateVariables) => {
  //     statisticRequest.codeTag = this.codeTag;
  //     statisticRequest.userId = this.userId;

  //     let statisticResponse = await ApiService.statisticUpdate(statisticRequest);
  //     if (statisticResponse.errorCode === 0) {
  //       this.showSuccess("Statistic", CrudlStatus.UPDATE);
  //     } else {
  //       this.showError("Statistic", CrudlStatus.UPDATE);
  //     }

  //     return statisticResponse;
  //   };
}



// WEBPACK FOOTER //
// ./src/components/Statistics/StatisticViewModel.js